import React, { createContext, useContext, useState } from 'react';

const LatestDataContext = createContext();

export const LatestDataProvider = ({ children }) => {
  const [latestData, setLatestData] = useState(null);

  return (
    <LatestDataContext.Provider value={{ latestData, setLatestData }}>
      {children}
    </LatestDataContext.Provider>
  );
};

export const useLatestData = () => useContext(LatestDataContext);
